import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getChat as getChatApi,
    addChat as addChatApi,
    deleteChat as deleteChatApi,
    bookmarkChat as bookmarkChatApi,
    getChatUsers,
    getChatRooms,
    createDirectChat,
    getRoomMessages,
    sendMessage,
    deleteMessage,
    markMessagesAsRead,
    updateOnlineStatus,
    getOnlineStatus
} from "../../helpers/fakebackend_helper";

export const getChat = createAsyncThunk("chat/getChat", async (roomId: any, { rejectWithValue }) => {
    try {
        const response = getChatApi(roomId);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to get chat' });
    }
});

export const addChat = createAsyncThunk("chat/addChat", async (event: any, { rejectWithValue }) => {
    try {
        const response = addChatApi(event);
        const data = await response;
        return data;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to add chat' });
    }
});

export const deleteChat = createAsyncThunk("Chat/deleteChat", async (event: any, { rejectWithValue }) => {
    try {
        const response = deleteChatApi(event);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to delete chat' });
    }
});

export const bookmarkChat = createAsyncThunk("Chat/bookmarkChat", async (event: any, { rejectWithValue }) => {
    try {
        const response = bookmarkChatApi(event);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to bookmark chat' });
    }
});

// New chat thunks
export const fetchChatUsers = createAsyncThunk("chat/fetchChatUsers", async (params: any = {}, { rejectWithValue }) => {
    try {
        const response = await getChatUsers(params);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to fetch chat users' });
    }
});

export const fetchChatRooms = createAsyncThunk("chat/fetchChatRooms", async (params: any = {}, { rejectWithValue }) => {
    try {
        const response = await getChatRooms(params);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to fetch chat rooms' });
    }
});

export const createDirectChatRoom = createAsyncThunk("chat/createDirectChatRoom", async (data: any, { rejectWithValue }) => {
    try {
        const response = await createDirectChat(data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to create direct chat room' });
    }
});

export const fetchRoomMessages = createAsyncThunk("chat/fetchRoomMessages", async ({ roomId, params }: { roomId: string, params?: any }, { rejectWithValue }) => {
    try {
        const response = await getRoomMessages(roomId, params);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to fetch room messages' });
    }
});

export const sendChatMessage = createAsyncThunk("chat/sendChatMessage", async ({ roomId, data }: { roomId: string, data: any }, { rejectWithValue }) => {
    try {
        const response = await sendMessage(roomId, data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to send message' });
    }
});

export const deleteChatMessage = createAsyncThunk("chat/deleteChatMessage", async (messageId: string, { rejectWithValue }) => {
    try {
        const response = await deleteMessage(messageId);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to delete message' });
    }
});

export const markChatMessagesAsRead = createAsyncThunk("chat/markChatMessagesAsRead", async (roomId: string, { rejectWithValue }) => {
    try {
        const response = await markMessagesAsRead(roomId);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to mark messages as read' });
    }
});

export const updateUserOnlineStatus = createAsyncThunk("chat/updateUserOnlineStatus", async (data: any, { rejectWithValue }) => {
    try {
        const response = await updateOnlineStatus(data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to update online status' });
    }
});

export const fetchUserOnlineStatus = createAsyncThunk("chat/fetchUserOnlineStatus", async (_, { rejectWithValue }) => {
    try {
        const response = await getOnlineStatus();
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to fetch online status' });
    }
});